import { useRootStore } from 'stores/RootStore'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'

export const usePioneerCredits = () => {
  const {
    tierUsageStore: { currentSubscription },
    creditUsageStore: { creditUsage },
  } = useRootStore()

  return (
    currentSubscription?.plan === PaymentPlanKey.VirtualMarketer &&
    currentSubscription?.status === 'active' &&
    creditUsage &&
    Object.keys(creditUsage).length > 0
  )
}
